import { IPublicClientApplication } from '@azure/msal-browser';

const clearMsalCacheKeys = async (msalInstance: IPublicClientApplication) => {
  //! rimosso per storia https://bludata.atlassian.net/browse/FOCUSPLUS-6040
  //! in teoria, msalInstance.clearCache() dovrebbe essere sufficiente per svuotare la cache di MSAL
  await msalInstance?.clearCache(); // Svuota la cache di MSAL
  /*localStorage.removeItem('msal.token.keys'); // Elimina la chiave di indicizzazione

  // **Elimina tutte le altre chiavi correlate a MSAL**
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('msal.')) {
      localStorage.removeItem(key);
    }
  });

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('msal.')) {
      localStorage.removeItem(key);
    }
  });*/
};

export default clearMsalCacheKeys;
